import { createGetEndpoint } from '@sonar-software/sonar-http';

export const getDiagnostics =
	createGetEndpoint<void, { summary: string }>(`/api/v3/diagnostics?url=${encodeURI(window.location.href)}`);
